// TermsConditionsComponent.js

import React from "react";
import images from "../../constant/images";
import { Nav } from "../../layouts/navbar/nav";
import { useTranslation } from "react-i18next";

const TermsConditions = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div
      className="flex flex-col gap-6 md:gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Nav />

      <div className="flex justify-center px-4 md:mx-16">
        <div className="w-full md:w-[80%] lg:w-[60%]  px-4 sm:px-8 md:px-16 mb-10 md:mb-20 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] py-6  md:py-12 border rounded-xl md:rounded-3xl bg-white">
          <h1 className="text-xl md:text-2xl font-bold mb-4">
            {t("terms.title")}
          </h1>
          <p className="mb-4">{t("terms.introduction")}</p>

          <h2 className="text-base md:text-lg font-semibold mt-4 md:mt-6">
            {t("terms.section1")}
          </h2>
          <ul className="list-decimal pl-5 mb-4">
            {t("terms.section1Content", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>

          <h2 className="text-base md:text-lg font-semibold mt-4 md:mt-6">
            {t("terms.section2")}
          </h2>
          <ul className="list-decimal pl-5 mb-4">
            {t("terms.section2Content", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>

          <h2 className="text-base md:text-lg font-semibold mt-4 md:mt-6">
            {t("terms.section3")}
          </h2>
          <p className="mb-4">{t("terms.section3Content")}</p>
          <h2 className="text-base md:text-lg font-semibold mt-4 md:mt-6">
            {t("terms.section4")}
          </h2>
          <ul className="list-decimal pl-5 mb-4">
            {t("terms.section4Content", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
